module.exports = __webpack_public_path__ + "static/media/new_armor_background.039b3d9b.jpg";